export default __webpack_public_path__ + "static/peat-moss-a54a5eb302ca8a98ea6208efd5d0a0de.jpeg";